import { api } from "../services/Api";

export function UseRefreshToken() {
  const refreshToken = localStorage.getItem("barte-refresh-token")
  async function sendRefreshToken () {
    try {
      const { data } = await api.post("public/auth/refresh-token", {
        refreshToken: String(refreshToken)
      })
      const { token } = data;
      localStorage.setItem("barte-auth-token", token)
      document.location.reload();
    } catch (error: any) {
      console.log("error inside refresh:", error);
      if (error?.response?.status === 401) {
        localStorage.removeItem("barte-auth-token");
        window.location.replace(process.env.REACT_APP_FRONT_URL + "login");
      }
    }
  }
  return {
    sendRefreshToken
  }
}